export const friendlyDate = date => {
  const dt = new Date(date);
  const hj = new Date();
  const months = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro"
  ];

  if (dt.getFullYear() !== hj.getFullYear()) {
    return `${dt.getDate()} de ${months[dt.getMonth()]} de ${dt.getFullYear()}`;
  }

  return `${dt.getDate()} de ${
    months[dt.getMonth()]
  }, às ${`00${dt.getHours()}`.slice(-2)}:${`00${dt.getMinutes()}`.slice(-2)}`;
};

export const simpleDateHour = date => {
  const dt = new Date(date);

  return `${`00${dt.getDate()}`.slice(-2)}/${`00${dt.getMonth() + 1}`.slice(
    -2
  )}/${dt.getFullYear()}  ${`00${dt.getHours()}`.slice(
    -2
  )}:${`00${dt.getMinutes()}`.slice(-2)}:${`00${dt.getSeconds()}`.slice(-2)}`;
};
